import { createContext, useContext } from "react";

interface SessionContextValue {
  /**
   * A unique identifier for the current page session. This can be used to correlate telemetry events that occur during a user's session on a single page.
   * Will reset if the user refreshes the page or navigates away and back. Does not persist across different pages/components.
   */
  pageSessionId: string;
}

interface SessionProviderProps {
  children: React.ReactNode;
}

const SessionContext = createContext<SessionContextValue | undefined>(
  undefined,
);

export const SessionProvider: React.FC<SessionProviderProps> = ({
  children,
}) => {
  const pageSessionId = crypto.randomUUID();

  return (
    <SessionContext.Provider value={{ pageSessionId }}>
      {children}
    </SessionContext.Provider>
  );
};

export const useSessionContext = (): SessionContextValue | undefined => {
  return useContext(SessionContext);
};

export { SessionContext };
